import React from "react";

/**
 * Segmented Daily / Monthly (or similar) toggle for chart toolbars.
 */
const ChartViewToggle = ({ leftLabel, rightLabel, isRightActive, onChange }) => (
  <div className="dash-segmented" role="group" aria-label={`${leftLabel} or ${rightLabel}`}>
    <button
      type="button"
      className={!isRightActive ? "active" : ""}
      aria-pressed={!isRightActive}
      onClick={() => onChange(false)}
    >
      {leftLabel}
    </button>
    <button
      type="button"
      className={isRightActive ? "active" : ""}
      aria-pressed={isRightActive}
      onClick={() => onChange(true)}
    >
      {rightLabel}
    </button>
  </div>
);

export default ChartViewToggle;
